<!--
 * @message: 列表筛选组件中条件筛选输入，包含字符串，下拉选择组件，时间选择组件
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-03-29 13:24:28
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_List_Selections\Filter_Input_Fields.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:56:57
-->
<template>
  <v-container
    fluid
    :class="
      object.type == 'string'
        ? object.sequence == 0
          ? 'ma-0 mb-n3 pa-0'
          : 'ma-0 my-n3 pa-0'
        : 'ma-0 pa-0'
    "
  >
    <!-- string有字符验证 -->
    <slot :name="object.name" :object="object" :index="index">
      <v-sheet
        class="d-inline-block text-truncate transparent"
        v-if="showLabel"
      >
        <span class="text--secondary">
          {{ $t(object.label) }}
        </span>
      </v-sheet>
      <v-autocomplete
        ref="selectstaff"
        v-if="
          (type == 'select' && datatype == 'all_staff') ||
          (type == 'select' && datatype == 'staff')
        "
        :items="allDataTrans"
        :placeholder="
          datatype == 'all_staff' || datatype == 'staff'
            ? $t('label_essweb_leaveBalance_list_staffNameLabel') +
              '/' +
              $t('label_essweb_leaveBalance_list_staffIdLabel')
            : $t(object.label)
        "
        height="auto"
        :filled="filled"
        :disabled="object.disabled"
        :chips="object.chips ? object.chips : object.multiple"
        :deletable-chips="object.multiple"
        :small-chips="object.multiple"
        v-model="modelValue"
        color="primary "
        dense
        :filter="$staffFilter"
        :menu-props="{
          offsetY: true,
          transition: 'slide-y-transition',
          rounded: true,
          contentClass: 'elevation-4',
        }"
        :no-data-text="
          loading
            ? $t('message_essweb_system_tips_loadingLabel')
            : $vuetify.noDataText
        "
        search-input
        :multiple="object.multiple"
        hide-details
        single-line
        :item-text="selectKey"
        :item-value="valueKey"
      >
        <template v-slot:no-data>
          <noContent />
        </template>
        <template
          v-slot:prepend-item
          v-if="object.multiple && allDataTrans && allDataTrans.length > 0"
        >
          <v-list-item
            v-if="object.multiple"
            class="px-4"
            @click="
              $nextTick(() => {
                if (modelValue.length === allDataTrans.length) {
                  modelValue = [];
                } else {
                  modelValue = [];
                  allDataTrans.map((item) => {
                    modelValue.push(item[valueKey]);
                  });
                }
              })
            "
          >
            <v-list-item-action class="mx-0 my-0 mr-1">
              <span
                class="material-icons-round"
                :class="
                  modelValue.length !== 0 &&
                  modelValue.length === allDataTrans.length
                    ? 'primary--text'
                    : modelValue.length > 0 &&
                      modelValue.length !== allDataTrans.length
                    ? 'primary--text'
                    : 'text--secondary'
                "
              >
                {{
                  modelValue.length !== 0 &&
                  modelValue.length === allDataTrans.length
                    ? "check_box"
                    : modelValue.length > 0 &&
                      modelValue.length !== allDataTrans.length
                    ? "indeterminate_check_box"
                    : "check_box_outline_blank"
                }}
              </span>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  $t("label_essweb_system_select_selectAllLabel")
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <template v-slot:selection="data">
          <slot name="selection" :data="data" :object="object">
            <v-chip
              v-bind="data.attrs"
              class="my-1"
              close
              pill
              :small="smallChip"
              :input-value="data.selected"
              v-if="data.index < $selectSetting.maxChips"
              @click="data.select"
              @click:close="removeChips(data.item[valueKey])"
            >
              <StaffAvatar
                left
                :small="smallChip"
                contentClass="white--text"
                :isTemp="data.item.is_temp"
                :src="data.item.staff_avatar"
                :staff_name="data.item[showKey]"
              />
              {{ $getCommonLangValue(data.item[showKey]) }}
            </v-chip>
            <v-hover
              v-slot="{ hover }"
              v-if="data.index === $selectSetting.maxChips"
            >
              <span
                :class="hover ? 'rounded primary--text' : 'text--secondary'"
                @click.stop="
                  () => {
                    showSelected = true;
                    if ($refs.selectstaff) {
                      $refs.selectstaff.blur();
                    }
                  }
                "
                class="py-2"
              >
                ...{{ object.value.length - $selectSetting.maxChips
                }}{{ $t("label_essweb_selection_moreItemLabel") }}
              </span>
            </v-hover>
          </slot>
        </template>
        <template v-slot:item="data">
          <!-- <template v-if="object.multiple"> -->
          <v-list-item
            :class="
              modelValue.indexOf(data.item[valueKey]) != -1
                ? 'primary lighten-5'
                : 'transparent'
            "
            v-bind="data.attrs"
            v-on="data.on"
            class="px-4 transparent"
          >
            <v-list-item-action v-if="object.multiple">
              <v-checkbox
                color="primary"
                :ripple="false"
                class="primary--text"
                :value="modelValue.indexOf(data.item[valueKey]) != -1"
                :input-value="modelValue.indexOf(data.item[valueKey]) != -1"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-avatar v-if="object.avatar">
              <slot name="item.avatar" :data="data" :object="object">
                <StaffAvatar
                  size="36"
                  :isTemp="data.item.is_temp"
                  :src="data.item.staff_avatar"
                  :staff_name="data.item[showKey]"
                />
              </slot>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <slot name="item.title" :data="data" :object="object">
                  {{ $getCommonLangValue(data.item[showKey]) }}
                  <span class="text--secondary text-caption-xs">{{
                    data.item[selectKey]
                  }}</span>
                </slot>
              </v-list-item-title>
              <v-list-item-subtitle v-if="object.twoLine">
                <slot name="item.subtitle" :data="data" :object="object">
                  {{
                    $getCommonLangValue(
                      data.item[subKey] ? data.item[subKey] : ""
                    )
                  }}
                </slot>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <!-- </template>
          <slot name="item" :data="data" :object="object" v-else /> -->
        </template>
      </v-autocomplete>
      <v-autocomplete
        ref="select"
        v-if="
          type == 'select' &&
          datatype != 'all_staff' &&
          datatype != 'staff' &&
          datatype != 'tree'
        "
        :items="allDataTrans"
        :placeholder="$t(object.label)"
        filled
        height="auto"
        :disabled="object.disabled"
        :chips="object.multiple"
        :deletable-chips="object.multiple"
        :small-chips="object.multiple"
        v-model="modelValue"
        color="primary "
        dense
        :menu-props="{
          offsetY: true,
          transition: 'slide-y-transition',
          rounded: true,
          contentClass: 'elevation-4',
        }"
        :no-data-text="
          loading
            ? $t('message_essweb_system_tips_loadingLabel')
            : $vuetify.noDataText
        "
        :multiple="object.multiple"
        hide-details
        single-line
        :item-text="selectKey"
        :item-value="valueKey"
      >
        <template v-slot:no-data>
          <noContent />
        </template>
        <template
          v-slot:prepend-item
          v-if="object.multiple && allDataTrans.length > 0"
        >
          <v-list-item
            v-if="object.multiple"
            class="px-4"
            @click="
              $nextTick(() => {
                if (modelValue.length === allDataTrans.length) {
                  modelValue = [];
                } else {
                  modelValue = [];
                  allDataTrans.map((item) => {
                    modelValue.push(item[valueKey]);
                  });
                }
              })
            "
          >
            <v-list-item-action class="mx-0 my-0 mr-1">
              <span
                class="material-icons-round"
                :class="
                  modelValue.length !== 0 &&
                  modelValue.length === allDataTrans.length
                    ? 'primary--text'
                    : modelValue.length > 0 &&
                      modelValue.length !== allDataTrans.length
                    ? 'primary--text'
                    : 'text--secondary'
                "
              >
                {{
                  modelValue.length !== 0 &&
                  modelValue.length === allDataTrans.length
                    ? "check_box"
                    : modelValue.length > 0 &&
                      modelValue.length !== allDataTrans.length
                    ? "indeterminate_check_box"
                    : "check_box_outline_blank"
                }}
              </span>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  $t("label_essweb_system_select_selectAllLabel")
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </template>
        <template v-slot:selection="data">
          <slot name="selection" :data="data" :object="object">
            <StatusChip
              v-if="object.statusChip && data.index < $selectSetting.maxChips"
              :slideColor="data.item.f1 ? data.item.f1 : 'grey'"
              :bgColor="
                data.item.f2 ? data.item.f2 : 'rgba(155, 153, 153, 0.3)'
              "
              :icon="object.statusChip == 'icon'"
              close
              @close="removeChips(data.item[valueKey])"
            >
              <template v-slot:status>
                {{ $getCommonLangValue(data.item[showKey]) }}
              </template>
            </StatusChip>
            <v-chip
              v-bind="data.attrs"
              class="my-1"
              :class="data.item.f1 ? 'white--text' : ''"
              close
              :color="data.item.f1 ? data.item.f1 : undefined"
              :small="smallChip"
              :input-value="data.selected"
              v-if="!object.statusChip && data.index < $selectSetting.maxChips"
              @click="data.select"
              @click:close="removeChips(data.item[valueKey])"
            >
              {{ $getCommonLangValue(data.item[showKey]) }}
            </v-chip>
            <v-hover
              v-slot="{ hover }"
              v-if="data.index === $selectSetting.maxChips"
            >
              <span
                :class="hover ? 'rounded primary--text' : 'text--secondary'"
                @click.stop="
                  () => {
                    showSelected = true;
                    if ($refs.selectstaff) {
                      $refs.selectstaff.blur();
                    }
                  }
                "
                class="py-2"
              >
                ...{{ object.value.length - $selectSetting.maxChips
                }}{{ $t("label_essweb_selection_moreItemLabel") }}
              </span>
            </v-hover>
          </slot>
        </template>
        <template v-slot:item="data">
          <v-list-item
            :class="
              modelValue.indexOf(data.item[valueKey]) != -1
                ? 'primary lighten-5'
                : 'transparent'
            "
            v-bind="data.attrs"
            v-on="data.on"
            class="px-4 transparent"
          >
            <v-list-item-action v-if="object.multiple">
              <v-checkbox
                color="primary"
                :ripple="false"
                class="primary--text"
                :input-value="modelValue.indexOf(data.item[valueKey]) != -1"
                :value="modelValue.indexOf(data.item[valueKey]) != -1"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <slot name="item.title" :data="data" :object="object">
                  {{ $getCommonLangValue(data.item[showKey]) }}
                </slot></v-list-item-title
              >
              <v-list-item-subtitle v-if="object.twoLine">
                <slot name="item.subtitle" :data="data" :object="object">
                  {{ $getCommonLangValue(data.item[subKey]) }}
                </slot>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
      <v-text-field
        v-if="type == 'string'"
        :filled="filled"
        dense
        :rules="$GetRules(['_SpecialCharacters_Rules'], [$t(object.label)])"
        :placeholder="$t(object.label)"
        single-line
        v-model="modelValue"
      ></v-text-field>

      <DateTimePicker
        v-else-if="type == 'daterange'"
        isRequire
        hideDetail
        :type="type"
        :value="object.value"
        :defaultTime="object.value"
        :max="object.max"
        :min="object.min"
        :defaultStartTime="defaultStartDate"
        :defaultEndTime="defaultEndDate"
        :placeholder="$t('label_essweb_RosterRecord_list_seTimeLabel')"
        @change="
          (time, isre) => {
            dateTerminal = time;
            object.value = time;
            if (isre) {
              defaultStartDate = time ? time.split(' - ')[0] : '';
              defaultEndDate = time ? time.split(' - ')[1] : '';
            }
          }
        "
      />
      <DateTimePicker
        v-else-if="type == 'month'"
        isRequire
        hideDetail
        :type="type"
        :value="object.value"
        :defaultTime="object.value"
        :max="object.max"
        :min="object.min"
        :defaultStartTime="defaultStartDate"
        :defaultEndTime="defaultEndDate"
        :placeholder="$t(object.label)"
        @change="
          (time, isre) => {
            dateTerminal = time;
            object.value = time;
          }
        "
      />
      <SelectDepartments
        v-if="type == 'select' && datatype == 'tree'"
        :items="allDataTrans"
        v-model="object.value"
        :placeholder="$t(object.label)"
        :multiple="object.multiple"
        :disabled="object.disabled"
        :show-label="false"
        @view-select="showSelected = true"
      />
      <!-- <v-text-field
        v-else
        filled="filled"
        dense
        hide-details
        :placeholder="$t(object.label)"
        single-line
        v-model="modelValue"
      ></v-text-field> -->
    </slot>
    <!-- tools -->
    <SelectValue
      :show="showSelected"
      @close="showSelected = false"
      v-model="modelValue"
      @select="
        (e, item) => {
          removeChips(e, item);
        }
      "
      :model-key="valueKey"
      :object="object"
    />
    <!-- tools -->
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import SelectValue from "@/components/MRC_ESS_List_Selections/selectValue";

export default {
  name: "filter_input_field",
  components: { SelectValue },
  // model: {
  //   prop: "value",
  //   event: "input",
  // },
  props: {
    // value: { default: "", type: [Number, String, Array] },
    object: { default: undefined, type: [Object] },
    filled: { default: true, type: Boolean },
    showLabel: { default: true, type: Boolean },
    index: { default: undefined, type: [Number, String] },
    smallChip: { default: true, type: [Boolean, Number] }, //小chips
    refresh: { default: true, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone"]),
    type() {
      return this.object ? this.object["type"] : undefined;
    },
    allDataTrans() {
      return this.$getSelectTrans(
        this.allData,
        this.object["data"]["modelKey"]
      );
    },
    subKey() {
      if (this.object && this.object["subKey"]) return this.object["subKey"];
      else {
        let data = this.object["data"];
        if (this.object && this.object["type"] == "select" && data) {
          return data["modelKey"] ? data["modelKey"] : "uuid";
        } else return "uuid";
      }
    },
    showKey() {
      if (this.object && this.object["showKey"]) return this.object["showKey"];
      else {
        let data = this.object["data"];
        if (this.object && this.object["type"] == "select" && data) {
          return data["modelKey"] ? data["modelKey"] : "uuid";
        } else return "uuid";
      }
    },
    valueKey() {
      let data = this.object["data"];
      if (this.object && this.object["type"] == "select" && data) {
        return data["valueKey"] ? data["valueKey"] : "uuid";
      } else return "uuid";
    },
    selectKey() {
      let data = this.object["data"];
      if (this.object && this.object["type"] == "select" && data) {
        return data["modelKey"] ? data["modelKey"] : "uuid";
      } else return "uuid";
    },
  },
  watch: {
    modelValue(val) {
      let arr = [];
      if (this.object["type"] === "select") {
        if (this.object["multiple"]) {
          //多选
          arr = this.getSelected(this.allDataTrans, val, this.valueKey);
        } else {
          //单选
          arr = this.getSelected(
            this.allDataTrans,
            val ? [val] : [],
            this.valueKey
          );
        }
      }
      // departemnt
      this.$emit("change", this.object["name"], val, arr);
    },
    dateTerminal(val) {
      this.modelValue = val;
    },
    allDataTrans(val) {},
    "object.value": function (val) {
      //关闭chip时
      this.modelValue = val;
    },
    "object.data": {
      handler(val) {
        let data = val;
        if (this.object && this.object["type"] == "select" && val) {
          this.getSelectList(
            data["api"],
            data["args"],
            data["type"],
            data["table"],
            data["global"]
          );
        }
      },
      deep: true,
    },
  },
  mounted() {
    let data = this.object["data"];
    this.modelValue = this.object["value"];
    if (this.object && data && this.object["type"] == "select") {
      this.modelValue = [];
      this.datatype = data["url_type"];
      if (
        !data["url_type"] ||
        data["url_type"] == "primary" ||
        data["url_type"] == "staff" ||
        data["url_type"] == "tree"
      ) {
        if (
          data["immediate"] === undefined ||
          (data["args"] && data["immediate"])
        )
          //对于传参数的接口，配置是否需要立即请求,true:会执行两次
          this.getSelectList(
            data["api"],
            data["args"],
            data["type"],
            data["table"],
            data["global"]
          );
      } else if (data["url_type"] && data["url_type"] == "all_staff") {
        //获取所有员工
        this.$getStaffList().then((res) => {
          this.allData = res;
        });
      } else if (data["url_type"] && data["url_type"] == "prompt") {
        this.getPromptData(data["api"]);
      }
    }
  },
  data() {
    return {
      datatype: "",
      modelValue: "",
      loading: false,
      dateTerminal: "",
      defaultStartDate: "",
      defaultEndDate: "",
      allData: [],
      showSelected: false,
    };
  },
  methods: {
    removeChips(keyvalue, item) {
      if (this.object.multiple) {
        if (this.datatype == "tree") {
          const index = this.modelValue.indexOf(item);
          if (index >= 0) this.modelValue.splice(index, 1);
        } else {
          const index = this.modelValue.indexOf(keyvalue);
          if (index >= 0) this.modelValue.splice(index, 1);
        }
      } else {
        this.modelValue = "";
      }
    },
    getSelectList(url, args, type, table, global = false) {
      const that = this;
      that.allData = [];
      let data = {};
      if (args) {
        if (args["type"] !== undefined && args["type"] === "") return; //切换人员组
        if (args["dept_uuid"] !== undefined && args["dept_uuid"] === "") return; //切换部门
        if (args["vision"] !== undefined && args["vision"] === "") return; //切换部门
        for (let key in args) {
          data[key] = args[key];
        }
      }
      that.loading = true;
      that
        .$Request({
          method: "POST",
          table: table,
          url: url,
          data: data,
          type: type,
          global: global,
        })
        .then((res) => {
          that.allData = res.data ? res.data : [];
          that.loading = true;
        })
        .catch((err) => {
          that.loading = true;
        });
    },
    getSelected: function (items, selected, key) {
      let arr = [];
      if (selected == [] || !selected) return [];
      if (this.datatype == "tree") return selected; //department
      selected.map((item) => {
        let obj = items.find((ele) => ele[key].toString() === item.toString());
        if (obj) arr.push(obj);
      });
      return arr;
    },
    getPromptData: function (name) {
      const that = this;
      this.$findPrompt({
        prompt_name: name,
      }).then((res) => {
        that.allData = res.data ? res.data : [];
      });
    },
  },
};
</script>